module.exports = "/assets/data/8d0c2b996f448740bdb0b14ad91eadbd-CB4.data.json";